import { render, staticRenderFns } from "./CustomerLogin.vue?vue&type=template&id=19cd589a&scoped=true"
import script from "./CustomerLogin.vue?vue&type=script&lang=js"
export * from "./CustomerLogin.vue?vue&type=script&lang=js"
import style0 from "./CustomerLogin.vue?vue&type=style&index=0&id=19cd589a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cd589a",
  null
  
)

export default component.exports